module.exports = __webpack_public_path__ + "static/img/owner_bg2.85b0f4b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rule/owner_bg2.jpg
// module id = LAoM
// module chunks = 1